import { createDynamicThunk } from ".";

/**
 * LIST ClientEscalations
 */
export const fetchClientEscalationsThunk = createDynamicThunk({
  typePrefix: "clientEscalations/fetchClientEscalationsThunk",
  useHandleSearch: true,
});

/**
 * ADD / EDIT ClientEscalation
 */
export const submitClientEscalationThunk = createDynamicThunk({
  typePrefix: "clientEscalations/submitClientEscalationThunk",
  endpoint: "/client-escalation",
  method: "POST",
});

/**
 * Complete Client Escalation Detail
 */
export const completeClientEscalationsThunk = createDynamicThunk({
  typePrefix: "clientEscalations/completeClientEscalationsThunk",
  endpoint: "/client-escalation/updateMul",
  method: "POST",
});

/**
 * Delete Client Escalation
 */
export const deleteClientEscalationsThunk = createDynamicThunk({
  typePrefix: "clientEscalations/deleteClientEscalationsThunk",
  endpoint: "/client-escalation/deleteMul",
  method: "POST",
});

/**
 * GET Client Escalation Detail
 */
export const fetchClientEscalationDetailThunk = createDynamicThunk({
  typePrefix: "clientEscalation/fetchDetail",
  endpoint: "/client-escalation",
  method: "GET",
});

/**
 * EDIT ClientEscalation
 */
export const editClientEscalationThunk = createDynamicThunk({
  typePrefix: "clientEscalations/editClientEscalationThunk",
  endpoint: "/client-escalation",
  method: "PUT",
});

